import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router'; 
import { Observable } from 'rxjs';
import { UserService } from '../user.service';

@Injectable()
export class MultiUserGuardService implements CanActivate {

  constructor(
    private _router: Router,
    private _userService: UserService
  ){}

  canActivate(){
    let role = localStorage.getItem('role');

    if(role == 'USER' || role == 'ADMIN' || role == 'MULTI' || role=='AUTORIZADOR' || role=='DELEGADO' || role=='PAGADOR')  {
      return true;
    }else{
      this._router.navigate(['/home']);
      return false;
    }
  }
    
}